<template>
  <div class="set-title">
    <el-dialog
        title="一键下单"
        :visible="true"
        @close="handleClose"
        width="660px"
    >
      <div class="box">
        <div class="left">
          <img :src="info.picUrl" alt="">
        </div>
        <div class="right">
          <p>{{ info.goodsName }}</p>
          <div v-for="(item, index) in info.specificationList" :key="index">
            <div style="display: flex;">
              <div class="" style="margin-top: 5px;">{{item.name}}：</div>
              <div style="display: flex;align-items: center;flex-wrap: wrap;flex: 1;">
                <div
                    v-for="(v,i) in item.value"
                    :key="i"
                >
                  <div v-if="v.url">
                    <img
                        :class="v.checked === '1' ? 'img1 active' : 'img1'"
                        @click="handleGG(item, v, i)"
                        :src="v.url"
                        alt=""
                    >
                  </div>
                  <div v-else>
                    <div
                        :class="v.checked === '1' ? 'text active' : 'text'"
                        @click="handleGG(item, v, i)"
                    >{{v.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p style="margin-top: 5px;">价格：
            {{info.money}}</p>
          <p style="margin-top: 5px;">数量：
            <el-input-number
                v-model="num"
                :min="1"
                size="small"
                :max="9999999999"
                :controls="false"
                label="描述文字"
            >
            </el-input-number>
          </p>
        </div>
      </div>
      <div class="flex">
        <span style="color: #ff0000;">*</span>
        <p>收货地址：</p>
        <el-select
            size="small"
            style="width: 100%;"
            v-model="value1"
            clearable
            placeholder="请选择收货地址"
        >
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.newAddress"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <span style="color: #ff0000;width: 6px;height: 1px;"></span>
        <p>买家留言：</p>
        <el-input
            size="small"
            style="width: 100%;"
            v-model="value2"
            placeholder="请输入买家留言"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button :loading="loading" size="small" type="primary" @click="doConfirm">下 单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "orders",
  props: {
    row: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
  },
  data(){
    return{
      value1: '',
      value2:'',
      options: [],
      info: {},
      num: 1,
      loading: false,
    }
  },
  mounted() {
    this.getInfo()
    this.getAddress()
  },
  methods: {
    // 点击规格(非图片)
    handleGG (item, v) {
      item.value = item.value.map((c) => {
        if (c.name === v.name) {
          c.checked = '1'
          c.newName = item.name + ':' + v.name
        } else {
          c.checked = '0'
          c.newName = ''
        }
        return { ...c }
      })
      this.screenItem()
    },
    // 筛选选择商品
    screenItem(){
      let data = this.info.specificationList
          .map((v) => {
            return v.value
          })
          .flat()
          .filter((c) => {
            return c.newName
          })
          .map((b) => {
            return b.newName
          })
      this.info.attrPriceList.forEach((v) => {
        if (data.length === this.info.specificationList.length) {
          if (this.isArrayEqual(data, v.sp_data.split(';'))) {
            // console.log(v)
            this.info.productInfo = v
            this.info.money = v.price || this.info.price
            this.info.taotianGoodsSkuId = v.taotianGoodsSkuId
            // initialUnitPrice.value = v.price
          }
        }
      })
      console.log(this.info)
    },
    // 判断数组内容相同不考虑顺序
    isArrayEqual (arr1, arr2){
      const a1 = arr1.map((i) => i)
      let a2 = arr2.map((i) => i)
      let tempArr = []
      if (a1.length !== a2.length) {
        return false
      } else {
        for (let i = 0; i < a1.length; i++) {
          if (a2.indexOf(a1[i]) !== -1) {
            a2.splice(a2.indexOf(a1[i]), 1)
            tempArr.push(a1[i])
          } else {
            tempArr = []
            break
          }
        }
        return tempArr.length === arr2.length
      }
    },
    async getInfo(){
      const params = {
        url: this.row.taobaoUrl,
      }
      const res = await this.$http.get("taobaoShop/getGoodsInfo", {params})
      this.info = res.data.data
    },
    async getAddress(){
      const res = await this.$http.get("taobaoShop/addressListNoPage")
      this.options = res.data.data.map(v=>{
        if(!v.receiverPhone){
          v.receiverPhone = ''
        }
        return{
          ...v,
          newAddress: v.receiverName + v.receiverPhone
        }
      })
      console.log(this.options,11)
    },
    async doConfirm(){
      // console.log('this.info',this.value1)
      if(!this.info.money){
        return this.$message.error('请先选择规格');
      }
      if(!this.value1){
        return this.$message.error('请先选择地址');
      }
      const params = {
        goodsName: this.info.goodsName,//   商品名称
        goodsCount: this.num,//  商品数量
        price: this.info.money,//   商品单价
        taotianGoodsId: this.info.taotianGoodsId,//  淘天商品ID
        taotianGoodsSkuId: this.info.taotianGoodsSkuId,//  淘天商品skuID
        orderRemark: this.value2,//    买家留言
        orderAddressId: this.value1,//    地址id
        orderId: this.row.id,//     订单ID
      }
      this.loading = true
      try {
        const res = await this.$http.post("taobaoShop/createPurchaseOrder",params)
        if(res.data.code === 200){
          this.$message({message:res.data.message,type: 'success'});
          this.$options.confirm(true)
        }else {
          this.$message.error(res.data.message);
        }
      }finally {
        this.loading = false
      }
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.box{
  display: flex;
  img{
    width: 160px;
    height: 160px;
  }
  .right{
    margin-left: 15px;
    .title111{
      font-size: 17px;
      margin: 5px 0;
    }
    .img1{
      width: 50px;
      height: 50px;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
      border-radius: 5px;
      border: 2px solid #f2f3f5;
      &.active {
        border-radius: 5px;
        border: 2px solid #ff8726;
      }
    }
    .text{
      padding: 3px 6px;
      cursor: pointer;
      border-radius: 5px;
      border: 2px solid #f2f3f5;
      margin-right: 3px;
      &.active {
        border-radius: 5px;
        border: 2px solid #ff8726;
      }
    }
  }
}
.flex{
  display: flex;
  align-items: center;
  margin-top: 10px;
  p{
    width: 75px;
  }
  .el-input{
    flex: 1;
  }
  .el-select{
    flex: 1;
  }
}

.set-title {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .vue-barcode-element{
    width: 100%!important;
  }
  ::v-deep .el-dialog__body{
    padding-top: 10px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .el-input-number--medium {
    width: 100%;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}
</style>
